import $ from "jquery";
import kendo from '@progress/kendo-ui';

import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { noRecordTemplate, preventFilterAutocomplete, getTooltipTilte,  disableAddBtn, enableAddBtn, disableActionBtn, enableActionBtn } from '@/app/shared/grid-functionality/grid-functionality.js';
import { parentChildCheckboxesBehavior } from '@/app/shared/dropdowns-functionality/tree.js';
import { isValueInDataSource } from '@/app/shared/dropdowns-functionality/combobox.js';
import { EventBus } from '@/app/shared/services/event-bus.js';
import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { KendoService } from '@/app/shared/services/kendo-service/kendoService.js';
import { billingGroupAssignmentService } from "@/app/billing-management/shared/services/bg-assignment-service.js";
import { genericAutoCompleteService } from '@/app/shared/services/kendo-service/genericAutoCompleteService.js';
import { getActionNameEnum, PopupTypeEnums, UploadExcelEnums, BGAssignmentEnums, SaveResultEnums, getNationalityEnums } from '@/app/billing-management/shared/config/billing-management-enums.js';
/////// components
import SaveConfigModal from "./save-config-modal/save-config-modal.vue"
import ConfirmPopup from '@/app/shared/components/confirm-popup/confirm-popup.vue';
import Loader from "@/app/shared/layouts/components/loader/loader.vue";

import moment from 'moment';
import config from '@/app/billing-management/shared/config/billing-management-config.json';

import localeEn from "@/app/billing-management/locales/en";
import localeAr from "@/app/billing-management/locales/ar";
localStorage.getItem("NG_TRANSLATE_LANG_KEY") === "en" ? import("@/app/billing-management/theme/billing-management.scss") : import("@/app/billing-management/theme/billing-management-rtl.scss");

export default {
    name: "bg-assignment",
    data() {
        return {
            isKSAEntity: false,
            inValidSearchContractror: false,
            applyBtnIsClicked: false,
            productsODataSetted: false,
            editModel: {},
            sorted: false,
            openConfigModelFlag: false,
            selectedProductID: null,
            disableContractor: false,
            allSelections: [],
            productCategoryListClosed: true,
            prodCatOldIds: [],
            prodCatAddedItems: [],
            prodCatDeletedItems: [],
            //selectedProductClassOld: 0,
            hasPatientTransaction: false,
            configurationsSaved: false,
            tooltipSaveConfiguration: this.$i18n.t('BillingManagement.BGAssignment.ConfigureUnassignedProducts'),
            tooltipUploadDownload: this.$i18n.t('BillingManagement.BGAssignment.assignBGDisabledTooltip'),
            showBGAssignGrid: false,
            productClassificationDS: [],
            productCategoryDS: [],
            confirmdata: {},
            styleBorder: "",
            hasEditRow: false,
            isLoading: false,
            editPermition: this.showHideElement("Edit"),
            addPermission: this.showHideElement("Edit"),
            deletePermission: this.showHideElement("Edit"),
            downloadPermission: this.showHideElement("Edit"),
            uploadPermission: this.showHideElement("Edit"),
            saveConfigPermission: this.showHideElement("Edit"),
            formData: {
                productClassificationID: null,
                productCategoryIDs: null,
                contractorID: null,
                contractorName: null,
                IsNotCoverd: true,
                assignStatus: null
            },
            contractorDS: this.fillContractorsAutoComplete().data,
            assignStatusDS: [
                { Name: this.$i18n.t('BillingManagement.BGAssignment.Assigned'), ID: 1 },
                { Name: this.$i18n.t('BillingManagement.BGAssignment.UnAssigned'), ID: 2 },
            ],
            productsDS: {},
            filterableObject: {
                mode: 'row',
                extra: 'false',
                messages: {
                    search: true
                },
                operators: {
                    string: 'contains'
                }
            },
            uploadedFile: "",
            uploadFileInput: document.getElementById("uploadFileInput"),
            dateFormatForGrid: config.dateGridFormat,
            productBGAssignDS: {
                data: [],
                change: (e) => {
                    if (e.action == 'remove') {
                        if (e.sender.data()?.length) e.sender.data()[0].lastAdded = true;
                    }
                    // To Fix problem of adding empty rows while filtering and press add new
                    if (e.sender.filter() && e.sender.filter().filters.length > 0) {
                        $('.k-grid-add').attr("disabled", "disabled");
                    }
                    //else {
                    //    $('.k-grid-add').removeAttr("disabled", "disabled");
                    //}
                },
                pageSize: config.pageSize,
                schema: {
                    model: {
                        id: 'ID',
                        fields: {
                            ID: { type: "number", defaultValue: 0, editable: false },
                            ProductCategory: { type: "string", editable: false },
                            ProductName: { type: "string", editable: false },
                            ProductID: { type: "number", editable: false },
                            BillingGroup: {
                                type: "string",
                                validation: {
                                    BillingGroupRequried: (input) => {
                                        if ((input.is("[name='BillingGroup']") && (input.val() == null) || input.val() === "")) {
                                            input.attr("data-BillingGroupRequried-msg", this.$i18n.t("Common.Required"));
                                            return false;
                                        }
                                        return true;
                                    },
                                }
                            },
                            BillingGroupID: { type: "number" },
                            StartDate: {
                                type: "date",
                                validation: {
                                    RequriedStartDate: (input) => {
                                        if ((input.is("[name='StartDate']") && (input.val() == null) || input.val() === "")) {
                                            input.attr("data-RequriedStartDate-msg", this.$i18n.t("Common.Required"));
                                            return false;
                                        }
                                        return true;
                                    },
                                    InValidDate: (input) => {
                                        if (input.is("[name='StartDate']") && input.val() != "") {
                                            if (!input.data("kendoDatePicker").value()) {
                                                input.attr("data-InValidDate-msg", this.$i18n.t('BillingManagement.Shared.InvalidDate'));
                                                return false;
                                            }
                                        }
                                        return true;
                                    },
                                    //------ No Duplication date
                                    DateDuplication: (input) => {
                                        if (input.is("[name='StartDate']") && input.val() !== null && input.val() !== "") {
                                            let dataSource = $("#productBGAssignID").data("kendoGrid").dataSource.data();

                                            if (dataSource.length && dataSource.length > 1 && this.isDateDuplicated(dataSource, input)) {
                                                input.attr("data-DateDuplication-msg", this.$i18n.t('Common.Duplicated'));
                                                return false;
                                            }
                                        }
                                        return true
                                    },
                                    //------ overlapping date
                                    DateOverlap: (input) => {
                                        if (input.is("[name='StartDate']") && input.val() !== null && input.val() !== "") {
                                            let dataSource = $("#productBGAssignID").data("kendoGrid").dataSource.data();

                                            if (dataSource.length && dataSource.length > 1 && this.isDateOverlapped(dataSource, input)) {
                                                input.attr("data-DateOverlap-msg", this.$i18n.t('BillingManagement.BGAssignment.OverlapDateErrorMsg'));
                                                return false;
                                            }
                                        }
                                        return true
                                    },
                                },
                            },
                            ModifiedTS: { type: "string" },
                            lastAdded: { type: "boolean", default: false },
                            HasPatientTransaction: { type: "boolean", default: false }
                        }
                    }
                }
            },
            editableConfig: {
                mode: 'inline',
                createAt: "top",
                confirmation: false,
                destroy: false
            },
            billingGroupDS: [],
            bGAssignGridCommand: [
                {
                    name: 'edit',
                    iconClass: {
                        update: "fas fa-check-circle",
                        cancel: "far fa-times-circle"
                    },
                    text: { edit: this.$i18n.t('Common.Edit'), cancel: this.$i18n.t('Common.Cancel'), update: this.$i18n.t('Common.Update') },
                    template: () => {
                        return this.editPermition ? `<a role='button' class='k-button k-button-icontext k-grid-edit k-grid-editrow'><span class="editAnchor">${this.$i18n.t('Common.Edit')}</span><img src=${require('@/assets/svg/ic_edit.svg')} /></a>` : '';
                    }
                },
                {
                    name: "showConfirmPopup",
                    text: this.$i18n.t('Common.Delete'),
                    iconClass: 'fas fa-trash-alt',
                    click: e => this.showConfirmPopup(getActionNameEnum().deleteRow, e),
                    template: () => {
                        return this.deletePermission ? `<a role='button' class='k-button k-button-icontext k-grid-showConfirmPopup k-grid-deleterow' ><span class="deleteAnchor">${this.$i18n.t('Common.Delete')} </span><img src=${require('@/assets/svg/ic_delete.svg')} /></a>` : ''
                    }
                }
            ],
        };
    },
    methods: {
        GetLocalNationality() {
            billingGroupAssignmentService.GetLocalNationality((response) => {
                if (response?.data) {
                    this.isKSAEntity = response.data == getNationalityEnums().KSA;
                }
            }, (error) => {
                console.log('GetLocalNationality',error)
            });

        },
        assignStatusDataBound() {
            this.allSelections = this.assignStatusDS.map(x => x.ID)
            $("#assignStatusID").data("kendoDropDownTree").value(this.allSelections)
            this.formData.assignStatus = this.allSelections;
        },
        //addNew() {
        //    if ($("#productBGAssignID").data("kendoGrid").dataSource.sort()?.length) {
        //        $("#productBGAssignID").data("kendoGrid").dataSource.sort({})
        //    }
        //    $("#productBGAssignID").data("kendoGrid").addRow();
        //},
        showHideElement(clientAction) {
            return modelServices.ifUserHasPermission(clientAction, this.$route.name);
        },
        isDateOverlapped(dataSource, input) {
            for (let i = 0; i < dataSource.length; i++) {
                let dateValue = new Date(moment(input.val(), "DD/MM/YYYY").format("MM/DD/YYYY"));
                let formatDate = new Date(moment(dataSource[i].StartDate, "DD/MM/YYYY").format("MM/DD/YYYY"));
                //let formatDate = kendo.toString(dataSource[i].StartDate, config.monthDayDateFormat);
                //let selectedDate = kendo.toString(dateValue , config.dayMonthDateFormat);
                if (dataSource[i].uid != input[0].kendoBindingTarget.source.uid && this.isDateBefore(new Date(dateValue), new Date(formatDate))) { // different rows
                    return true;
                }

            }
        },
        isDateBefore(date1, date2) {
            return date1.getTime() < date2.getTime()
        },
        isDateDuplicated(dataSource, input) {
            for (let i = 0; i < dataSource.length; i++) {
                let dateValue = new Date(moment(input.val(), "DD/MM/YYYY").format("MM/DD/YYYY"));
                let formatDate = new Date(moment(dataSource[i].StartDate, "DD/MM/YYYY").format("MM/DD/YYYY"));
                //let formatDate = kendo.toString(dataSource[i].StartDate, config.monthDayDateFormat);
                //let selectedDate = kendo.toString(dateValue , config.dayMonthDateFormat);
                if (dataSource[i].uid != input[0].kendoBindingTarget.source.uid && this.isDatesEqual(new Date(dateValue), new Date(formatDate))) { // different rows
                    return true;
                }

            }
        },
        isDatesEqual(date1, date2) {
            return date1.getTime() === date2.getTime()
        },
        customDisableFilterAndPagging(gridSelector) {
            $(`#${gridSelector} .k-filtercell`).addClass("disable-filter");
            $(`#${gridSelector} .k-filtercell *`).attr("disabled", "disabled")
                
            $(`#${gridSelector} .k-pager-wrap`).addClass("k-state-disabled  disable-filter");
            $(`#${gridSelector} [data-role='columnsorter']`).addClass("disable-sort");
            $(`#${gridSelector} .k-pager-sizes`).attr("disabled", "disabled").addClass("disable-filter").css('border', 'none');
        },
        customEnableFilterAndPagging(gridSelector) {
            $(`#${gridSelector} .k-filtercell`).removeClass("disable-filter");
            $(`#${gridSelector} .k-filtercell *`).removeAttr("disabled", "disabled")

            $(`#${gridSelector} .k-pager-wrap`).removeClass("k-state-disabled  disable-filter");
            $(`#${gridSelector} [data-role='columnsorter']`).removeClass("disable-sort");
            $(`#${gridSelector} .k-pager-sizes`).removeAttr("disabled", "disabled").removeClass("disable-filter");
        },
        editRow: function (e) {
            //$("#productBGAssignID").data("kendoGrid").dataSource.sort({ field: "ID", dir: "desc" })
            this.editModel = JSON.parse(JSON.stringify(e.model));
            this.hasEditRow = true;
            this.customDisableFilterAndPagging('productBGAssignID')
            disableActionBtn(e);
            disableAddBtn(e);
            $('#productsGridID .assignBG.blue-btn-no-border').attr("disabled", "disabled").addClass('disabledClick');
        },
        cancelRow: function (e) {
            e.preventDefault();
            this.hasEditRow = false;
            enableActionBtn(e);
            this.customEnableFilterAndPagging('productBGAssignID')
            enableAddBtn(e);
            let grid = $('#productBGAssignID');
            let dataSource = grid.data("kendoGrid").dataSource
            let dataItem = dataSource._data;
            dataSource.cancelChanges(dataItem);

            if (this.editModel.ID) {
                //kendo.toString(x, config.dayMonthDateFormat)
                //moment(this.editModel.StartDate, "MM/DD/YYYY").format("DD/MM/YYYY");
                //let dateObj = new Date(this.editModel.StartDate).toLocaleDateString('en-GB')
                //if (dateObj != 'Invalid Date') {
                //    e.model.StartDate = dateObj;
                //}
                //else e.model.StartDate = this.editModel.StartDate
                e.model.StartDate = this.editModel.StartDate;
                e.model.BillingGroup = this.editModel.BillingGroup;
                e.model.BillingGroupID = this.editModel.BillingGroupID;
                $('#productBGAssignID').data('kendoGrid').refresh();
            }
            
            $('.assignBG.blue-btn-no-border').removeAttr("disabled", "disabled").removeClass('disabledClick');
        },
        saveRow: function (e) {
            e.model.ProductID = this.selectedProductID;
            e.preventDefault();
            if (e.model.isNew()) {
                e.model.lastAdded = true
            }

            this.saveModel = {
                ID: e.model.ID,
                ProductID: e.model.ProductID,
                ContractorID: this.formData.contractorID,
                BillingGroupID: e.model.BillingGroupID,
                StartDate: (new Date(moment(e.model.StartDate, "DD/MM/YYYY").format("MM/DD/YYYY"))).toDateString()
            }
            this.isLoading = true
            billingGroupAssignmentService.AddProductBillingGroup(this.saveModel, (result) => {
                if (result.data) {
                    switch (result.data.SaveResult) {
                        case parseInt(BGAssignmentEnums().SavedSuccessfully): {
                            ////////// refresh billing group grid without calling API
                            if (!e.model.ID || !e.model.id) { //// for new rows
                                e.model.ID = result.data.ProductBillingGroupId;
                                e.model.id = result.data.ProductBillingGroupId;
                                e.model.StartDate = new Date(e.model.StartDate).toLocaleDateString('en-GB')

                                this.productBGAssignDS.data.unshift(e.model);
                                $('#productBGAssignID').data("kendoGrid").dataSource.data(this.productBGAssignDS.data);
                                $("#productBGAssignID").data("kendoGrid").refresh();
                                /////// to update no of Assignations in master grid
                                const col = $('#productsGridID').find(`.masterCol[data-productId='${e.model.ProductID}']`);
                                const row = col[0].closest('tr');
                                const grid = row.closest("#productsGridID");
                                let dataItem = $(grid).getKendoGrid().dataItem($(row));
                                ++dataItem.NumberOfAssignations;
                                if (!dataItem.IsAssigned) {
                                    dataItem.IsAssigned = true
                                }
                                $("#productsGridID").data("kendoGrid").refresh();

                            }
                            else {
                                e.model.StartDate = kendo.toString(e.model.StartDate, config.dayMonthDateFormat)
                               // $('#productBGAssignID').data("kendoGrid").dataSource.data(this.productBGAssignDS.data);
                                $("#productBGAssignID").data("kendoGrid").refresh();
                            }
                            e.model.ModifiedTS = result.data.ModifiedTS

                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Success')}</h6><p>${this.$i18n.t('Common.SavedSuccessfully')}</p>`, 'success');
                            this.hasEditRow = false;
                            enableActionBtn(e);
                            this.customEnableFilterAndPagging('productBGAssignID')
                            enableAddBtn(e);
                            $('#productsGridID .assignBG.blue-btn-no-border').removeAttr("disabled", "disabled").removeClass('disabledClick');
                            this.isLoading = false
                            break;
                        }
                        case parseInt(BGAssignmentEnums().ErrorInSaving): {
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.Error')}</p>`, 'error')
                            this.isLoading = false;
                            break;
                        }
                        case parseInt(BGAssignmentEnums().InvalidBillingGroupName): {
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('BillingManagement.BGAssignment.InvalidBillingGroup')}</p>`, 'error')
                            this.isLoading = false;
                            break;
                        }
                        case parseInt(BGAssignmentEnums().InactiveBillingGroupName): {
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('BillingManagement.BGAssignment.SelectInActiveBillingGroup')}</p>`, 'error')
                            this.isLoading = false;
                            break;
                        }
                        case parseInt(BGAssignmentEnums().Concurrency):
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Common.Concurrency')}</p>`, 'warning')
                            this.isLoading = false;
                            break;
                    }

                }
                else {
                    this.isLoading = false;
                    this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.SomethingWrong')}</p>`, 'error');
                }
            });

        },
        startDateEditor(container, options) {
            if (options.model.isNew()) options.model.StartDate = '';
            $(`<input required data-required-msg="${this.$i18n.t("Common.Required")}" name="${options.field}"
                   placeholder="${this.$i18n.t('BillingManagement.BGAssignment.StartDate')}"/>`)
                .appendTo(container)
                .kendoDatePicker({
                    format: config.dayMonthDateFormat,
                });
        },
        // Date Picker Filter in Grid
        dateTemplate(args) {
            args.element.kendoDatePicker({
                format: config.dayMonthDateFormat
            });
        },
        billingGroupEditor(container, options) {
            $(`<input required data-required-msg= "${this.$i18n.t('Common.Required')}"  name="${options.field}" id="${options.field}"  data-bind="value:BillingGroupID"/>`)
                .appendTo(container)
                .kendoDropDownTree({
                    autoBind: true,
                    dataTextField: "text",
                    dataValueField: "id",
                    valuePrimitive: true,
                    filter: 'contains',
                    //autoWidth: true,
                    placeholder: this.$i18n.t('Common.SelectPlaceholder') + ' ' + this.$i18n.t('BillingManagement.PriceInquiry.BillingGroup'),
                    noDataTemplate: this.$i18n.t('Common.NoDataToDisplay'),
                    dataSource: this.billingGroupDS,
                    //value: options.model.BillingGroupID,
                    change: (e) => {
                        options.model.BillingGroupID = +(e.sender.value());
                        options.model.BillingGroup = e.sender.text();
                    },
                    select: (e) => {
                        let data = e.sender.element.data('kendoDropDownTree').dataItem(e.node);
                        options.model.BillingGroupID = data.id;
                        options.model.BillingGroup = data.text;
                    },
                })
        },
        clearFormData() {
            this.showConfirmPopup(getActionNameEnum().clearAllData, "");
        },
        applyFormDataToGrid() {
            this.isLoading = true;
            this.showBGAssignGrid = false;
            this.productsODataSetted = false;
            let data = new KendoService(billingGroupAssignmentService.GetProductsAssignedURL() + "&ProductCategoryID=" + this.formData.productCategoryIDs.toString() + "&ContractorId=" + this.formData.contractorID + "&IsNotCoverd=" + this.formData.IsNotCoverd + "&IsAssigned=" + this.formData.assignStatus.toString(), config.pageSize, "ID",
                {
                    ID: { defaultValue: 0, type: "number" },
                    ProductCategory: { type: "string", editable: false },
                    ProductName: { type: "string", editable: false },
                    ProductID: { type: "number", editable: false },
                    ModifiedTS: { type: "string" },
                    IsAssigned: { type: "boolean" },
                    NumberOfAssignations: { type: "number" }

                }, "ProductName", true, "asc", true)
            if (data) {
                this.productsDS = data?.data;
                this.productsODataSetted = true;
                this.applyBtnIsClicked = true;
            }
            /*$(".k-grid .k-loading-image").hide();*/
        },
        fillContractorsAutoComplete() {
            return new genericAutoCompleteService(billingGroupAssignmentService.getContractorsActiveList, 5, '', null, "Name", "Name", "Name", null, null);
        },
        getProdCategoriesWithProductClassID(productClassificationID) {
            this.isLoading = true;
            billingGroupAssignmentService.GetProdCategories(productClassificationID, (response) => {
                if (response.data) {
                    this.productCategoryDS = new kendo.data.HierarchicalDataSource({
                        data: response.data
                    });
                }
                else {
                    this.productCategoryDS = new kendo.data.HierarchicalDataSource({
                        data: []
                    });
                }
                this.isLoading = false;
            })
        },
        productClassificationChanged(e) {
            let val = e.sender.element.data("kendoDropDownTree").value()
            if (this.checkProductsGridHasData()) {
                const ddlID = e.sender.element.attr("id");
                this.handleCloseDDTreeAndEmptyGridFilter(ddlID);
                this.showConfirmPopup(getActionNameEnum().productClassificationChange, e);
            }
            else {
                if (val) {
                    this.formData.productClassificationID = Number(val)
                    this.getProdCategoriesWithProductClassID(this.formData.productClassificationID)
                }
                else {
                    this.formData.productClassificationID = null
                    this.productCategoryDS = new kendo.data.HierarchicalDataSource({
                        data: []
                    });
                }
                this.formData.productCategoryIDs = null;
                $("#ProductCategory").data("kendoDropDownTree").value('');
            }
            //this.selectedProductClassOld = this.formData.productClassificationID 
        },
        parentChildCheckboxesBehavior: e => parentChildCheckboxesBehavior(e),
        productCategoryOpened() { this.productCategoryListClosed = false },
        productCategoryClosed(e) {
            this.productCategoryListClosed = true;
            this.productCategoryChanged(e)
        },
        checkProductsGridHasData() {
            let gridData = $('#productsGridID').data("kendoGrid").dataSource.data();
            let filters = $("#productsGridID").data("kendoGrid").dataSource.filter();
            return gridData.length > 0 || (filters?.filters.length && gridData.length == 0)
        },
        productCategoryChanged(e) {
            this.parentChildCheckboxesBehavior(e)
            if (this.productCategoryListClosed) {
                this.prodCatOldIds = this.formData.productCategoryIDs
                this.formData.productCategoryIDs = e.sender._values;
                
                if (this.doesProdCategotyIdsChanged(e) && this.checkProductsGridHasData()) {
                    this.showConfirmPopup(getActionNameEnum().productCategoryChange, e);
                }
            }

        },
        doesProdCategotyIdsChanged(e) {
            let sameIds
            if (this.prodCatOldIds?.length == e.sender?._values?.length) {
                let oldSortedIds = this.prodCatOldIds.sort();
                let sortedCurrentIds = (e.sender._values).sort();
                sameIds = oldSortedIds.every((val, index) => val == sortedCurrentIds[index])
            }
            return ((this.prodCatOldIds?.length != e.sender?._values?.length) || (this.prodCatOldIds?.length == e.sender?._values?.length && !sameIds))
        },
        isValueInDataSource: (e) => isValueInDataSource(e),
        contractorChanged: function (e) {
            this.inValidSearchContractror = false
            const inputText = e.sender.element[0].value;
            if (inputText != "") {
                this.inValidSearchContractror = !this.isValueInDataSource(e);
                if (this.inValidSearchContractror) return;
                else if (!this.inValidSearchContractror && this.checkProductsGridHasData()) {
                    this.showConfirmPopup(getActionNameEnum().changeContractor, e);
                }
            }
            else if (inputText == ""){
                if ($('#productsGridID').data("kendoGrid").dataSource.data().length == 0) {
                    $("#contractorComboBoxID").data("kendoAutoComplete").value('');
                    this.formData.contractorID = null;
                    this.formData.contractorName = null;
                    this.configurationsSaved = false;
                    this.formData.IsNotCoverd = true;
                }
                if (this.checkProductsGridHasData()) {
                    $("#contractorComboBoxID").data("kendoAutoComplete").value('');
                    let filters = $("#productsGridID").data("kendoGrid").dataSource.filter();
                    if (filters?.filters?.length) {
                        $("#productsGridID").data("kendoGrid").dataSource.filter(null);
                    }
                    this.showConfirmPopup(getActionNameEnum().changeContractor, "");
                }
            }
            //if (this.checkProductsGridHasData() && inputText != "" && data != undefined) {
            //    this.showConfirmPopup(getActionNameEnum().changeContractor, e);
            //}
        },
        contractorSelected: function (e) {
            this.inValidSearchContractror = false
            if ((!this.formData.contractorID && this.checkProductsGridHasData()) || (this.formData.contractorID != null && e.dataItem?.ID != this.formData.contractorID && this.checkProductsGridHasData())) {
                //e.preventDefault()
                let autoComplete = $(`#contractorComboBoxID`).data("kendoAutoComplete");
                autoComplete.close();
                this.showConfirmPopup(getActionNameEnum().changeContractor, e);
            }
            else {
                if (e.dataItem.IsNotCovered === true || e.dataItem.IsNotCovered === false) {
                    this.formData.IsNotCoverd = e.dataItem.IsNotCovered;
                    this.configurationsSaved = true
                }
                else if (e.dataItem.IsNotCovered === null) {
                    this.configurationsSaved = false;
                    this.formData.IsNotCoverd = true;
                }
                this.formData.contractorID = e.dataItem.ID
                this.formData.contractorName = e.dataItem.Name;
            }
        },
        openSaveConfigModel() {
            this.openConfigModelFlag = true;
            this.$nextTick(() => {
                this.$refs['config-comp'].$refs['save-config-modal'].show();
            })
        },
        saveConfig(configSaved, isNotCoverd) {
            this.configurationsSaved = configSaved;
            this.formData.IsNotCoverd = isNotCoverd;
            $("#productsGridID").getKendoGrid().dataSource.read();
            $("#productsGridID").data("kendoGrid").refresh();
        },
        //confirmation popup
        showConfirmPopup: function (actionName, e = "") {
            this._bv__modal.show('modal-scoped')
            this.styleBorder = ""
            this.confirmdata.iconName = 'text-danger fas fa-exclamation-triangle';
            this.confirmdata.headerTitle = this.$i18n.t('Common.Alert');
            this.confirmdata.confirmBtnText = this.$i18n.t('Common.No');
            this.confirmdata.cancelBtnText = this.$i18n.t('Common.Yes');
            this.confirmdata.messageText = this.$i18n.t('BillingManagement.BGAssignment.ChangeAnySelectionConfirmMsg')
            this.confirmdata.messageText = (actionName == getActionNameEnum().productClassificationChange || actionName == getActionNameEnum().clearAllData || actionName == getActionNameEnum().productCategoryChange || actionName == getActionNameEnum().assignStatusChange || actionName == getActionNameEnum().changeContractor) ? this.$i18n.t('BillingManagement.BGAssignment.ChangeAnySelectionConfirmMsg') :
                actionName == getActionNameEnum().deleteRow ? this.$i18n.t('Common.DeleteConfirmation') : '';
            this.confirmdata.qmark = this.$i18n.t('Common.QuestionMark');
            this.confirmdata.actionName = actionName;
            this.confirmdata.selectedType = e;
            this.confirmdata.eventBtn = (e != null ? e.currentTarget : null);
            if (actionName == getActionNameEnum().deleteRow) {
                var grid = $("#productBGAssignID").data("kendoGrid");
                let obj = grid.dataItem(e.currentTarget.closest("tr"))
                this.confirmdata.id = obj.ID;
                this.confirmdata.modifiedTs = obj.ModifiedTS;
                this.confirmdata.productID = obj.ProductID;
            }
        },
          downloadContractorProducts() {
              if (this.formData.productCategoryIDs != null) {
                  this.isLoading = true;
                  billingGroupAssignmentService.downloadExcel(this.formData.productCategoryIDs, this.formData.contractorID,this.formData.IsNotCoverd, this.formData.assignStatus.toString(), (response) => {
                      this.isLoading = false;

                      let uploadExcelEnums = Number(new TextDecoder().decode(response.data));
                      if (uploadExcelEnums == UploadExcelEnums().Concurrency) {
                        this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Common.Concurrency')}</p>`, 'warning'); 
                    }
                     else if (response.data.byteLength > 0) {
                          let fileName = this.formData.contractorID ? 'BillingGroupAssignment' + ` - ${this.formData.contractorName}` : 'BillingGroupAssignment'

                          var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                          var objectUrl = URL.createObjectURL(blob);
                          var a = document.createElement("a");
                          document.body.appendChild(a);
                          a.style = "display: none";
                          a.href = objectUrl;
                          a.download = fileName;
                          a.click();
                      }
                      else {
                          this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.Error')}</p>`, 'error');
                          //this.showPopupNotification(this.$i18n.t('Common.Error'), this.$i18n.t('Common.Error'), 'error');
                      }


                  }, (error) => {
                      this.isLoading = false;
                      if (error) {
                          console.log(error);
                          this.showPopupNotification(`<h6>${this.$i18n.t('Common.Failure')}</h6><p>${this.$i18n.t('Common.Failure')}</p>`, 'error');
                          //this.showPopupNotification(this.$i18n.t('Common.Failure'), this.$i18n.t('Common.Failure'), 'error');
                      }
                  });
              }
             
          },
          uploadContractorProducts() {
              this.uploadFileInput = document.getElementById("uploadFileInput");
              this.uploadFileInput.click();
          },
          uploadFileRequest() {
              this.uploadedFile = this.$refs.file.files[0];
              var formData = new FormData();
              formData.append("UploadedExcel", this.uploadedFile);
             // formData.append("selectedContractorID", this.formData.contractorID); 
              if (this.$refs.file.files.length > 0) {
                  let fileName = this.$refs.file.files[0].name;
                  let fileExt = fileName.substr((fileName.lastIndexOf('.') + 1)).toLowerCase().trim();

                if (fileExt != "xlsx") {
                    this.showUploadExcelResultPopup(UploadExcelEnums().FileIsNotExcel, PopupTypeEnums().Error)
                }
                else {
                    this.isLoading = true;
                    billingGroupAssignmentService.uploadFiles(formData, this.formData.contractorID, (result) => {
                        this.isLoading = false;
                        if (result) {
                            let uploadExcelEnums = Number(new TextDecoder().decode(result.data))
                            if (result.data == null || result.data == "" || result.data.byteLength == 0 || uploadExcelEnums == UploadExcelEnums().Success) {
                                this.showUploadExcelResultPopup(UploadExcelEnums().Success, PopupTypeEnums().Success);
                                if ($('#productsGridID').data("kendoGrid").dataSource.data().length > 0) {
                                    $("#productsGridID").getKendoGrid().dataSource.read();
                                    $("#productsGridID").data("kendoGrid").refresh();
                                }
                                else {
                                    this.applyFormDataToGrid()
                                }
                                if (this.showBGAssignGrid == true) {
                                    $('#productBGAssignID').data("kendoGrid").dataSource.data([]);
                                    this.showBGAssignGrid = false
                                }
                               
                            }
                            else if (uploadExcelEnums == UploadExcelEnums().Concurrency) {
                                this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Common.Concurrency')}</p>`, 'warning'); 
                            }
                            else if (uploadExcelEnums == UploadExcelEnums().FileIsNotExcel) {
                                this.showUploadExcelResultPopup(UploadExcelEnums().FileIsNotExcel, PopupTypeEnums().Error)
             
                            }
                            else if (uploadExcelEnums == UploadExcelEnums().FileIsNull
                                    || uploadExcelEnums == UploadExcelEnums().FileIsEmpty
                                    || uploadExcelEnums == UploadExcelEnums().InvalidContractor) {
                                this.showUploadExcelResultPopup(uploadExcelEnums, PopupTypeEnums().Error)
                            }
                            else if (result.data.byteLength > 0) {
                                this.showUploadExcelResultPopup(UploadExcelEnums().DataValidationErrors, PopupTypeEnums().Warning)
                                let fileName = this.formData.contractorID ? 'BillingGroupAssignment' + ` - ${this.formData.contractorName}` : 'BillingGroupAssignment'
                                var blob = new Blob([result.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                var objectUrl = URL.createObjectURL(blob);
                                var a = document.createElement("a");
                                document.body.appendChild(a);
                                a.style = "display: none";
                                a.href = objectUrl;
                                a.download = fileName;
                                a.click();
                            }
                        }
                        //else {
                        //    this.isLoading = false;
                        //    this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.Error')}</p>`, 'error');
                        //}
                    },)

                }
            }
              else {
                  this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('BillingManagement.BGAssignment.SelectFile')}</p>`, 'error');
              }
              this.uploadedFile = '';
              $("#uploadFileInput").val('');
          },
        showUploadExcelResultPopup: function (uploadExcelEnums, uploadType) {
            this.confirmdata = {}
            this.confirmdata.confirmBtnText = this.$i18n.t('Common.Ok');

            if (uploadType == PopupTypeEnums().Error) {
                this.styleBorder = ""
                this.confirmdata.iconName = 'text-danger fas fa-exclamation-triangle';
                this.confirmdata.headerTitle = this.$i18n.t('Common.Alert');
                if (uploadExcelEnums == UploadExcelEnums().FileIsNull) {
                    this.confirmdata.messageText = this.$i18n.t('BillingManagement.BGAssignment.ExcelFileEmpty')
                }
                else if (uploadExcelEnums == UploadExcelEnums().FileIsEmpty) {
                    this.confirmdata.messageText = this.$i18n.t('BillingManagement.BGAssignment.ExcelFileEmpty')
                }
                else if (uploadExcelEnums == UploadExcelEnums().InternalServerError) {
                    this.confirmdata.messageText = this.$i18n.t('BillingManagement.BGAssignment.InternalServerError')
                }
                else if (uploadExcelEnums == UploadExcelEnums().InvalidContractor) {
                    this.confirmdata.messageText = this.$i18n.t('BillingManagement.BGAssignment.InvalidContractorId')
                }
                else if (uploadExcelEnums == UploadExcelEnums().FileIsNotExcel) {
                    this.confirmdata.messageText = this.$i18n.t('BillingManagement.BGAssignment.UploadValidExcelFile')
                }
                

            }
            else if (uploadType == PopupTypeEnums().Success) {
                this.styleBorder = "successBorder"
                this.confirmdata.iconName = 'text-alert-JE fas fa-exclamation-triangle';
                this.confirmdata.headerTitle = this.$i18n.t('Common.Success');
                this.confirmdata.messageText = this.$i18n.t('BillingManagement.BGAssignment.SuccessUploadBlankFields')
            }
            else if (uploadType == PopupTypeEnums().Warning) {
                this.styleBorder = "errorBorder"
                this.confirmdata.iconName = 'text-alert-JE fas fa-exclamation-triangle';
                this.confirmdata.headerTitle = this.$i18n.t('Common.Warning');
                this.confirmdata.messageText = this.$i18n.t('Common.ExcelNeedReview')
            }
            this._bv__modal.show('modal-scoped')
            this.$refs.file.value = null;
        },
        noRecordTemplate,
        customNoRecordTemplate() {
            if (!this.formData.productClassificationID || this.formData.productCategoryIDs?.length == 0 ||
                (this.formData.productClassificationID && this.formData.productCategoryIDs?.length > 0 && !this.applyBtnIsClicked)) {
                return `<div class="norecords-template"><img class="nodata-img" src=${require('@/assets/svg/noDataFoundGreen.svg')} /> <div>${this.$i18n.t('BillingManagement.BGAssignment.ProductNoDataGridMsg')}</div>`
            } else {
                return noRecordTemplate();
            }
        },
        getTooltipTilte: e => getTooltipTilte(e),
        getCustomTooltipTilte: function (e) {
            document.querySelectorAll('[role="tooltip"]').forEach(tooltipDiv => {
                tooltipDiv.style.visibility = 'hidden'
            });
            let elem = e.target[0];
            if ((elem.offsetWidth < elem.scrollWidth) && elem.classList.contains('tooltipWidth')) {
                e.sender.content[0].parentElement.style.visibility = 'visible'
                return e.target.text();
            }
            if (elem.classList.contains("assignBGCol")) {
                e.sender.content[0].parentElement.style.visibility = 'hidden'
            }
            //else {
            //    e.sender.content[0].parentElement.style.visibility = 'hidden'
            //    return ""
            //}
        },
        onDataBound(e) {
            this.generalDataBound(e);
            if (this.showBGAssignGrid) {
                const col = $('#productsGridID').find(`.masterCol[data-productId='${this.selectedProductID}']`);
                $('#productsGridID tr').removeClass('markProductRow');
                col.closest("tr").addClass("markProductRow");
            }
            if (this.productsODataSetted && this.billingGroupDS.length == 0) {
                // $("#productsGridID .k-loading-image").hide();
                billingGroupAssignmentService.GetBillingGroupTree((result) => {
                    if (result?.data) {
                        this.billingGroupDS = result.data;
                    }
                    this.isLoading = false;
                });
                this.productsODataSetted = false
            }
            else if (this.billingGroupDS.length > 0){
                this.isLoading = false;
                this.productsODataSetted = false
            }
        },
        generalDataBound(e) {
            preventFilterAutocomplete(e);
            $('.k-grid .k-pager-wrap').removeClass('k-pager-lg')
            $('.k-grid .k-pager-wrap').removeClass('k-pager-sm')
            $('.k-filtercell [data-role="autocomplete"]').attr("placeholder", "");
        },
        onAssignBGDataBound(e) {
            this.generalDataBound(e);
            if (!this.addPermission) $('.k-grid-add').addClass("d-none");
            ///// last added 
            let gridData = $("#productBGAssignID").data("kendoGrid").dataSource.data();
            if (gridData?.length) {
                gridData.sort((a, b) => {
                    return (b.ID - a.ID)
                })

                gridData?.map((item,index )=> {
                    if (index == 0) item.lastAdded = true;
                    else item.lastAdded = false
                    if (!this.sorted) {
                        if (item.HasPatientTransaction) {
                            $(`[data-uid = ${item.uid}] .k-grid-editrow`).addClass("tooltipWidth disabledClick").removeClass("k-grid-edit");
                            $(`[data-uid = ${item.uid}] .k-grid-deleterow`).addClass("tooltipWidth disabledClick").removeClass("k-grid-showConfirmPopup");

                            $(`[data-uid = ${item.uid}] .editAnchor`).text(`${this.$i18n.t('BillingManagement.BGAssignment.TransactionTooltip')}`);
                            $(`[data-uid = ${item.uid}] .deleteAnchor`).text(`${this.$i18n.t('BillingManagement.BGAssignment.TransactionTooltip')}`);
                        }
                        else {
                            if (item.lastAdded) {
                                $(`[data-uid = ${item.uid}] .k-grid-editrow`).removeClass("tooltipWidth disabledClick").addClass("k-grid-edit");
                                $(`[data-uid = ${item.uid}] .k-grid-deleterow`).removeClass("tooltipWidth disabledClick").addClass("k-grid-showConfirmPopup");
                                $(`[data-uid = ${item.uid}] .editAnchor`).text(`${this.$i18n.t('Common.Edit')}`);
                                $(`[data-uid = ${item.uid}] .deleteAnchor`).text(`${this.$i18n.t('Common.Delete')}`);
                            }
                            else {
                                $(`[data-uid = ${item.uid}] .k-grid-editrow`).addClass("disabledClick").removeClass("k-grid-edit");
                                $(`[data-uid = ${item.uid}] .editAnchor`).text(`${this.$i18n.t('Common.Edit')}`);
                                $(`[data-uid = ${item.uid}] .k-grid-deleterow`).removeClass("tooltipWidth disabledClick").addClass("k-grid-showConfirmPopup");
                                $(`[data-uid = ${item.uid}] .deleteAnchor`).text(`${this.$i18n.t('Common.Delete')}`);
                            }

                        }
                    }
                    else {
                        $(`[data-uid = ${item.uid}] .k-grid-editrow`).addClass("disabledClick").removeClass("k-grid-edit");
                        $(`[data-uid = ${item.uid}] .k-grid-deleterow`).addClass("disabledClick").removeClass("k-grid-showConfirmPopup");
                    }
                });
            }
            
        },
        preventSortingOrPagingInEditMode: function (e) {
            const grid = e.sender;
            if (grid.content.find(".k-grid-edit-row").length >= 1) {
                e.preventDefault();
            }
            if (e.sender.element[0].id == 'productBGAssignID') {
                if (e.sort.dir != undefined) {
                    this.sorted = true;
                    disableAddBtn(e);
                }
                else {
                    this.sorted = false;
                    enableAddBtn(e);
                }
                
            }
        },
        onFilter(e) {
            e.sender.dataSource.filter(e.filter)
        },
        statusFilter(args) {
            args.element.kendoDropDownList({
                dataSource: {
                    data: [
                        { text: this.$i18n.t('BillingManagement.BGAssignment.Assigned'), value: true },
                        { text: this.$i18n.t('BillingManagement.BGAssignment.UnAssigned'), value: false }
                    ]
                },
                dataTextField: "text",
                dataValueField: "value",
                valuePrimitive: true,
                optionLabel: this.$i18n.t('Common.All'),
                autoWidth: true,

            });
        },
        assignmentStatusTemp(dataItem) {
            return (dataItem.IsAssigned) ? `<span class='statusHolder isactive'>${this.$i18n.t('BillingManagement.BGAssignment.Assigned')} (${dataItem.NumberOfAssignations})</span>`
                : `<span class='statusHolder isinactive'>${this.$i18n.t('BillingManagement.BGAssignment.UnAssigned')}</span>`
        },
        customGridCommand(dataItem) {
            let temp = ``;
            if ((this.formData.contractorID && this.configurationsSaved) || !this.formData.contractorID) {
                temp = `<a role='button' data-id=${dataItem.ID} data-assignmentStatus=${dataItem.IsAssigned} class='assignBG blue-btn-no-border'>
                            ${this.$i18n.t('BillingManagement.BGAssignment.AssignBillingGroup')}
                </a>`
            }
            else {
                temp = `
                  <div class="tooltipContext ">
	                <span class="tooltiptext">${this.$i18n.t('BillingManagement.BGAssignment.assignBGDisabledTooltip')}</span>
	               <a  role='button'   class='blue-btn-no-border disabledClick' >
                            ${this.$i18n.t('BillingManagement.BGAssignment.AssignBillingGroup')}
                    </a>
                </div>`
            }
            return temp;

        },
        showPopupNotification: function (msg, type) {
            this.popupNotificationWidget.show(msg, type);
        },
        closeBGAssignGrid(e) {
            if ($('#productBGAssignID').find('.k-grid-edit-row').length == 1) {
                this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('BillingManagement.BGAssignment.UnSavedBG')}</p>`, 'error');
                e.preventDefault();
                return;
            }

            this.showBGAssignGrid = false;
            $('tr').removeClass('markProductRow');
            this.hasEditRow = false;
            this.customEnableFilterAndPagging('productsGridID');
            this.sorted = false;
        },
        removeBGAssignRowFromGrid(item) {
            const row = item.closest("tr");
            const grid = row.closest("#productBGAssignID");
            let dataItem = $(grid).getKendoGrid().dataItem($(row));
            //handle if we delete last product in page
            let data = $("#productBGAssignID").data("kendoGrid").dataSource.data()
            const rowIndex = data.indexOf(dataItem);
            let currentPage = $("#productBGAssignID").getKendoGrid().dataSource.page();
            let pageSize = $("#productBGAssignID").getKendoGrid().dataSource.pageSize();
            if (currentPage != 1 && (rowIndex + 1) == data.length && rowIndex == (currentPage - 1) * pageSize) {
                $("#productBGAssignID").getKendoGrid().dataSource.page(currentPage - 1);
            }
            /////////////////
            $(grid).getKendoGrid().dataSource.data().remove(dataItem);
            this.productBGAssignDS.data = this.productBGAssignDS.data.filter(bgRow => bgRow.ID != dataItem.ID)
            $('#productBGAssignID').data("kendoGrid").dataSource.data(this.productBGAssignDS.data);

            $('#productBGAssignID').data('kendoGrid').refresh();
            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Success')}</h6><p>${this.$i18n.t('Common.DeletedSuccessfully')}</p>`, 'success');
        },
        deleteBGAssignRow(data) {
            this.isLoading = true;
            billingGroupAssignmentService.DeleteProductBillingGroup(data.id, data.modifiedTs, (result) => {
                if (result.data) {
                    switch (result.data) {
                        case parseInt(SaveResultEnums().Success): {
                            this.removeBGAssignRowFromGrid(data.eventBtn);

                            const col = $('#productsGridID').find(`.masterCol[data-productId='${data.productID}']`);
                            const row = col[0].closest('tr');
                            const grid = row.closest("#productsGridID");
                            let dataItem = $(grid).getKendoGrid().dataItem($(row));
                            --dataItem.NumberOfAssignations;
                            if (dataItem.NumberOfAssignations == 0) {
                                 dataItem.IsAssigned = false
                            }
                            $("#productsGridID").data("kendoGrid").refresh();
                            break;
                        }
                        case parseInt(SaveResultEnums().Failure): {
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.Error')}</p>`, 'error')
                            break;
                        }
                        case parseInt(SaveResultEnums().Concurrency):
                            this.showPopupNotification(`<h6>${this.$i18n.t('Common.Warning')}</h6><p>${this.$i18n.t('Common.Concurrency')}</p>`, 'warning')
                            break;

                    }
                    this.isLoading = false;
                }
                else {
                    this.isLoading = false;
                    this.showPopupNotification(`<h6>${this.$i18n.t('Common.Error')}</h6><p>${this.$i18n.t('Common.SomethingWrong')}</p>`, 'error');

                }
            });
        },
        handleCloseDDTreeAndEmptyGridFilter(ddlID) {
            $(`#${ddlID}`).data("kendoDropDownTree").close(); ////// fix bug popup disapeared by ddl
        },
        assignStatusChange(e) {
            this.assignStatusIds = this.formData.assignStatus
            this.formData.assignStatus = e.sender._values;

            if (this.assignStatusIds && this.assignStatusIds.length != e.sender._values.length && this.checkProductsGridHasData()) {
                const ddlID = e.sender.element.attr("id");
                this.handleCloseDDTreeAndEmptyGridFilter(ddlID)
                this.showConfirmPopup(getActionNameEnum().assignStatusChange, e);
            }
        }
    },
    mounted() {
        let that = this
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();
        
        $("body").on('click', 'a.assignBG:not(.tooltipWidth)', function (e) {
            if (!that.hasEditRow) {
                $('tr').removeClass('markProductRow');
                e.target.closest("tr").classList.add('markProductRow');

                that.showBGAssignGrid = true;
                that.customDisableFilterAndPagging('productsGridID')
                //e.target.classList.contains('assignBG')
                that.selectedProductID = this.dataset.id
                if (this.dataset.assignmentstatus == 'true') {
                    that.isLoading = true
                    /////// get data of billing Group Assign grid
                    billingGroupAssignmentService.GetBillingGroupsByProductID(that.selectedProductID,that.formData.contractorID, (result) => {
                        if (result.data) {
                            that.isLoading = false
                            let data = result.data
                            data.map(row => {
                                row.StartDate = new Date(row.StartDate).toLocaleDateString('en-GB');
                                return row
                            })
                            $('#productBGAssignID').data("kendoGrid").dataSource.data(data);
                            that.productBGAssignDS.data = data;
                        }
                    })
                }
                else if (this.dataset.assignmentstatus == 'false') {
                    setTimeout(() => {
                        $('#productBGAssignID').data("kendoGrid").dataSource.data([]);
                        that.productBGAssignDS.data = [];
                    }, 0)
                }
            }

        });

        // Requied Validation
        extend("required", {
            ...required,
            message: this.$i18n.t("Common.Required"),
        });

        //confirmed action popup
        EventBus.$on(`confirmed-action`, (data) => {
            if (data.actionName == getActionNameEnum().changeContractor) {
                let contractorComboBox = $("#contractorComboBoxID").data("kendoAutoComplete")
                let idMempType = data.selectedType?.sender?.dataItem()?.ID;
                if (idMempType) {
                    let itemData = data.selectedType.sender.dataItem()
                    contractorComboBox.value(itemData.Name)
                    this.formData.contractorID = itemData.ID;
                    this.formData.contractorName = itemData.Name;
                    if (itemData.IsNotCovered === true || itemData.IsNotCovered === false) {
                        this.formData.IsNotCoverd = itemData.IsNotCovered;
                        this.configurationsSaved = true
                    }
                    else if (itemData.IsNotCovered === null) {
                        this.configurationsSaved = false;
                        this.formData.IsNotCoverd = true;
                    }
                } else {
                    contractorComboBox.value("");
                    this.formData.contractorID = null;
                    this.formData.contractorName = null;
                    this.configurationsSaved = false;
                    this.formData.IsNotCoverd = true;
                }
                //$('#productsGridID').data("kendoGrid").dataSource.data([])
                this.productsDS = new kendo.data.HierarchicalDataSource({
                    data: [],
                });
                if (this.showBGAssignGrid == true) {
                    $('#productBGAssignID').data("kendoGrid").dataSource.data([]);
                    this.showBGAssignGrid = false
                }
                this.applyBtnIsClicked = false
                return true;
            }
            else if (data.actionName == getActionNameEnum().productClassificationChange) {
                this.formData.productClassificationID = data.selectedType.sender.value()
                if (this.formData.productClassificationID) this.getProdCategoriesWithProductClassID(this.formData.productClassificationID);
                this.formData.productCategoryIDs = null;
                $("#ProductCategory").data("kendoDropDownTree").value('');
                //$('#productsGridID').data("kendoGrid").dataSource.data([]);
                this.productsDS = new kendo.data.HierarchicalDataSource({
                    data: [],
                });
                if (this.showBGAssignGrid == true) {
                    $('#productBGAssignID').data("kendoGrid").dataSource.data([]);
                    this.showBGAssignGrid = false
                }
                this.applyBtnIsClicked = false
            }
            else if (data.actionName == getActionNameEnum().productCategoryChange) {
                this.formData.productCategoryIDs = data.selectedType.sender.value();
                //$('#productsGridID').data("kendoGrid").dataSource.data([]);
                this.productsDS = new kendo.data.HierarchicalDataSource({
                    data: [],
                });
                if (this.showBGAssignGrid == true) {
                    $('#productBGAssignID').data("kendoGrid").dataSource.data([]);
                    this.showBGAssignGrid = false
                }
                this.applyBtnIsClicked = false
            }
            else if (data.actionName == getActionNameEnum().assignStatusChange) {
                this.formData.assignStatus = data.selectedType.sender.value();
                //$('#productsGridID').data("kendoGrid").dataSource.data([]);
                this.productsDS = new kendo.data.HierarchicalDataSource({
                    data: [],
                });
                if (this.showBGAssignGrid == true) {
                    $('#productBGAssignID').data("kendoGrid").dataSource.data([]);
                    this.showBGAssignGrid = false
                }
                this.applyBtnIsClicked = false
            }
            else if (data.actionName == getActionNameEnum().clearAllData) {
                this.formData.productClassificationID = null;
                this.formData.productCategoryIDs = null;
                this.formData.IsNotCoverd = true;
                this.formData.assignStatus = this.allSelections;

                if (!this.disableContractor && this.formData.contractorID) {
                    this.formData.contractorID = null;
                    this.formData.contractorName = null;
                    $("#contractorComboBoxID").data("kendoAutoComplete").value('');
                    this.configurationsSaved = false;
                    this.formData.IsNotCoverd = true;
                }

                $("#ProductClassification").data("kendoDropDownTree").value('');
                $("#ProductCategory").data("kendoDropDownTree").value('');
                $("#assignStatusID").data("kendoDropDownTree").value(this.formData.assignStatus);
                //$('#productsGridID').data("kendoGrid").dataSource.data([]);
                this.productsDS = new kendo.data.HierarchicalDataSource({
                    data: [],
                });
                if (this.showBGAssignGrid == true) {
                    $('#productBGAssignID').data("kendoGrid").dataSource.data([]);
                    this.showBGAssignGrid = false
                }
                this.applyBtnIsClicked = false
            }
            else if (data.actionName == getActionNameEnum().deleteRow) {
                this.deleteBGAssignRow(data);
            }

        });
        EventBus.$on(`canceled`, (data) => {
            if (data.actionName == getActionNameEnum().changeContractor) {
                $("#contractorComboBoxID").data("kendoAutoComplete").value(this.formData.contractorName)
            }
            if (data.actionName == getActionNameEnum().productClassificationChange) {
                $(`#ProductClassification`).data("kendoDropDownTree").value(this.formData.productClassificationID);
            }
            if (data.actionName == getActionNameEnum().productCategoryChange) {
                this.formData.productCategoryIDs = this.prodCatOldIds
                $(`#ProductCategory`).data("kendoDropDownTree").value(this.prodCatOldIds)
            }
            if (data.actionName == getActionNameEnum().assignStatusChange) {
                this.formData.assignStatus = this.assignStatusIds
                $(`#assignStatusID`).data("kendoDropDownTree").value(this.assignStatusIds)
            }
        })
    },
    created() {
        if (!this.$route.params.id) {
            this.formData.contractorID = null
            this.disableContractor = false
        }
        else {
            this.formData.contractorID = Number(this.$route.params.id);
            this.disableContractor = true
        }
        //// get Product Classifications DS
        this.isLoading = true;
        billingGroupAssignmentService.GetProductClassifications((response) => {
            if (response?.data) {
                this.isLoading = false;
                this.productClassificationDS = new kendo.data.HierarchicalDataSource({
                    data: response.data
                });
            }
        }, (error) => {
            console.log(error)
        });
        this.GetLocalNationality();

    },
    computed: {
        disableClearBtn() {
            return !this.formData.productClassificationID || this.hasEditRow
        },
        disableApplyBtn() {
            return !this.formData.productCategoryIDs?.length || this.hasEditRow || this.inValidSearchContractror
        },
        disableSaveConfigBtn() {
            return !this.formData.contractorID || this.hasEditRow || this.inValidSearchContractror
        },
        disableUploadDownload() {
            return this.disableApplyBtn || (!this.disableApplyBtn && !this.applyBtnIsClicked)
                    || (Boolean(this.formData.contractorID) && !this.configurationsSaved) 
                    || (Boolean(this.formData.contractorID) && this.configurationsSaved && !this.applyBtnIsClicked)
        }
    },
    beforeDestroy() {
        EventBus.$off(`confirmed-action`);
        EventBus.$off('canceled');
    },
    i18n: {
        messages: {
            en: {
                ...localeEn,
            },
            ar: {
                ...localeAr,
            },
        },
    },
    components: {
        Loader,
        ConfirmPopup,
        ValidationProvider,
        ValidationObserver,
        SaveConfigModal
    },
};
